import { Checkbox, Col, DatePicker, Form, Input, Row, Select, Button, Modal, Table, Upload } from 'antd';
import { LoadingOutlined, UploadOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import './styles.css';
import DebounceSelect from './buscadorEjemplo';
import { 
    formatter, 
    getCostoPaseMedico, 
    getListadoEmpresas, 
    getListadoEspecialidades, 
    getListadoMedicos, 
    numeroALetras, 
    postGuardarPaseMedico, 
    SendConfirmationEmail,
    getLinkPago } from './peticiones';
import locale from 'antd/es/date-picker/locale/es_ES';
import 'dayjs/locale/es';
import moment from "moment";
import PaymentMethod from './PaymentMethod/MetodosPago';
import PaseMedico from './PaseMedico';
import EstatusScreen from './EstatusScreen';
import LinkPagoModal from './LinkPagoModal';
import { set } from 'lodash';
import { API_URL } from '../const';
moment.locale('es');


const MainForm = ({ setLoadingLinkPage }) => {


    const columns = [
        {
            title: 'Médico',
            dataIndex: 'label',
            render: (text) => <b>{text}</b>,
        },
        {
            title: 'Teléfono',
            dataIndex: 'txt_telConsul',
        },
        {
            title: 'Dirección',
            dataIndex: 'ciudad',
            key: 'ciudad',
            render: (ciudad, objeto) => (

                <>
                    <a href={`https://www.google.com/maps/search/?api=1&query=${objeto?.txt_calle + ' ' + objeto?.txt_noExt + ', ' + objeto?.colonia + ', ' + objeto?.cp + ', ' + objeto?.ciudad + ', ' + objeto?.estado}`}> {objeto?.txt_calle + ' ' + objeto?.txt_noExt + ', ' + objeto?.colonia + ', ' + objeto?.cp + ', ' + objeto?.ciudad + ', ' + objeto?.estado}</a>

                </>
            )
        },
    ];

    ///Archivos
    const [file1, setFile1] = useState(null);
    const [file2, setFile2] = useState(null);
    const [file3, setFile3] = useState(null);
    const [isFilesUploaded, setisFilesUploaded] = useState(true);


    const [focusedInput, setFocusedInput] = useState(null);
    const [deshabilitarbotones, setdeshabilitarbotones] = useState(true);
    const [listadoEspecialidades, setlistadoEspecialidades] = useState([]);
    const [listadoMedicos, setlistadoMedicos] = useState([]);


    //modales
    const [verModalTieneCita, setverModalTieneCita] = useState(false);
    const [verModalNoTieneCita, setverModalNoTieneCita] = useState(false);
    const [verModalCosto, setverModalCosto] = useState(false);
    const [verPaseMedico, setverPaseMedico] = useState(false);
    const [verMetodosPago, setverMetodosPago] = useState(false);
    const [verEstatusScreen, setverEstatusScreen] = useState(false);

    // informacionCompra 
    const [informacionCompra, setinformacionCompra] = useState([]);

    const [idPaseMedico, setidPaseMedico] = useState(0);

    //botones
    const [obtuvoCita, setobtuvoCita] = useState(false);

    //valores de los inputs
    const [nombres, setnombres] = useState(null);
    const [apellidoPaterno, setapellidoPaterno] = useState(null);
    const [apellidoMaterno, setapellidoMaterno] = useState(null);
    const [fechaNacimiento, setfechaNacimiento] = useState(null);
    const [genero, setgenero] = useState(null);
    const [correoElectronico, setcorreoElectronico] = useState(null);
    const [celular, setcelular] = useState(null);
    const [telefono, settelefono] = useState(null);
    const [estadoCivil, setestadoCivil] = useState(null);
    const [nacionalidad, setnacionalidad] = useState(null);

    const [nombresPaciente, setnombresPaciente] = useState(null);
    const [apellidoPaternoPaciente, setapellidoPaternoPaciente] = useState(null);
    const [apellidoMaternoPaciente, setapellidoMaternoPaciente] = useState(null);

    const [empresa, setempresa] = useState(null);
    const [especialidad, setespecialidad] = useState(null);
    const [medico, setmedico] = useState(null);
    const [medicoSeleccionado, setmedicoSeleccionado] = useState([]);
    const [parentesco, setparentesco] = useState(null);
    const [requiereFactura, setrequiereFactura] = useState(false);
    const [usoCFDI, setusoCFDI] = useState(null);

    const [costoPaseMedico, setcostoPaseMedico] = useState(0);


    // terminos y condiciones
    const [terminosYCondiciones, setterminosYCondiciones] = useState(false);

    const [error, setError] = useState(null);
    const [linkPago, setLinkPago] = useState(null);

    useEffect(() => {
        if (empresa != null) {
            if (Object.keys(empresa).length !== 0) {
                // El objeto no está vacío
                setespecialidad(null);
                setmedico(null);
                setlistadoMedicos([]);
                setlistadoEspecialidades([]);
                traeListadoEspecialidades(empresa.value);

            } else {
                // El objeto está vacío
                //console.log('El objeto está vacío');
            }
        } else {
            // El objeto está vacío
            //console.log('El objeto está vacío');
        }
    }, [empresa]);

    useEffect(() => {
        if (empresa != null && especialidad != null) {
            if (Object.keys(empresa).length !== 0 && especialidad != null) {
                // El objeto no está vacío
                setmedico(null);
                setlistadoMedicos([]);
                traeListadoMedicos(empresa.value, especialidad);
            } else {
                // El objeto está vacío
                //console.log('El objeto está vacío');
            }
        } else {
            // El objeto está vacío
            //console.log('El objeto está vacío');
        }
    }, [empresa, especialidad]);

    useEffect(() => {
        if (medico != null) {
            setmedicoSeleccionado([medico]);
            setverModalTieneCita(true);
        }
    }, [medico]);


    useEffect(() => {
        if (parentesco === "Titular") {
            if (nombres !== null && apellidoPaterno !== null && apellidoMaterno !== null && fechaNacimiento !== null && genero !== null && correoElectronico !== null && celular !== null && telefono !== null && estadoCivil !== null && nacionalidad !== null && empresa !== null && especialidad !== null && medico !== null && parentesco !== null && requiereFactura !== null) {
                setdeshabilitarbotones(false);
            } else {
                setdeshabilitarbotones(true);
            }
        } else if (parentesco != null && parentesco !== "Titular") {
            if (nombres !== null && apellidoPaterno !== null && apellidoMaterno !== null && fechaNacimiento !== null && genero !== null && correoElectronico !== null && celular !== null && telefono !== null && estadoCivil !== null && nacionalidad !== null && empresa !== null && especialidad !== null && medico !== null && parentesco !== null && requiereFactura !== null && nombresPaciente !== null && apellidoPaternoPaciente !== null) {
                setdeshabilitarbotones(false);
            } else {
                setdeshabilitarbotones(true);
            }
        }

    }, [nombres, apellidoPaterno, apellidoMaterno, fechaNacimiento, genero, correoElectronico, celular, telefono, estadoCivil, nacionalidad, nombresPaciente, apellidoPaternoPaciente, empresa, especialidad, medico, parentesco, requiereFactura]);


    useEffect(() => {

        if (requiereFactura === false) {
            if (file2 !== null && file3 !== null) {
                setisFilesUploaded(false);
            } else {
                setisFilesUploaded(true);
            }
        } else if (requiereFactura === true) {
            if (file1 !== null && file2 !== null && file3 !== null && usoCFDI !== null) {
                setisFilesUploaded(false);
            } else {
                setisFilesUploaded(true);
            }
        }

    }, [file1, file2, file3, requiereFactura, usoCFDI])


    const traeListadoEspecialidades = async (empresa) => {
        const respuesta = await getListadoEspecialidades(empresa);
        setlistadoEspecialidades(respuesta);
    }

    const traeListadoMedicos = async (empresa, especialidad) => {
        const respuesta = await getListadoMedicos(empresa, especialidad);
        respuesta?.map((x) => x.key = x.value);
        setlistadoMedicos(respuesta);
    }

    const handleFocus = (inputId) => {
        setFocusedInput(inputId);
    };

    const handleBlur = () => {
        setFocusedInput(null);
    };

    const handleMouseEnter = (inputId) => {
        setFocusedInput(inputId);
    };

    const handleMouseLeave = () => {
        setFocusedInput(null);
    };

    const getInputStyle = (inputId) => {
        return focusedInput === inputId ? 'custom-focus' : '';
    };

    const getSelectStyle = (inputId) => {
        return focusedInput === inputId ? 'custom-select-focus' : '';
    };

    const getButtonStyle = (inputId) => {
        return focusedInput === inputId ? 'custom-button-focus' : '';
    };


    const rectangleStyle = {
        width: '100%',
        height: '30px',
        backgroundColor: 'rgb(76, 73, 73)',
        marginTop: '-26px',
        marginLeft: '1px',
        borderRadius: '5px',
    };


    const fetchEmpresasList = async (palabra) => {
        if (palabra.replace(/ /g, "").length >= 3) {
            const respuesta = await getListadoEmpresas(palabra);
            return respuesta;
        }
    }

    const cambiarMedicoSeleccionado = (medico) => {
        setmedicoSeleccionado(medico);
        setmedico(medico[0]);
    }

    const rowSelection = {
        selectedRowKeys: medicoSeleccionado,
        onChange: (e) => cambiarMedicoSeleccionado(e)
    };

    const cambiarEstatusCita = (estatus) => {
        setobtuvoCita(estatus);
        setverModalNoTieneCita(false);
        setverModalTieneCita(false);
    }

    const props = {
        accept: ".pdf,image/png,image/jpeg", // Acepta archivos PDF, PNG y JPEG
        name: 'file',
        action: `${API_URL}/upload`,
        headers: {
            authorization: 'authorization-text',
        },
        enctype: 'multipart/form-data',

        maxCount: 1,
        // beforeUpload: file => {

        //     console.log(file);
        //     const folderName = 'nombre_de_la_carpeta'; // Asigna el nombre de la carpeta aquí
        //     const formData = new FormData();
        //     formData.append('file', file);
        //     formData.append('folderName', folderName); // Agrega el folderName al formData
        //     // console.log(JSON.stringify({formData}));

        //     // Asigna el formData actualizado al archivo
        //     file.data = formData;


        //     // Retorno falso para evitar la carga automática de archivos
        //     return true;
        // },
        //         onChange(info) {
        //     // console.log(info.file)

        //     // if (info.file.status === 'done') {

        //     //     // message.success(`${ se ha cargado correctamente.`);
        //     //   } else if (info.file.status === 'error') {
        //     //     // message.error(`${info.file.name} ha fallado al cargarse.`);
        //     //   }
        // //   if (info.file.status === 'done') {
        // //     message.success(`${info.file.name} file uploaded successfully`);
        // //   } else if (info.file.status === 'error') {
        // //     message.error(`${info.file.name} file upload failed.`);
        // //   }
        // },
    };

    const data = (nombre) => {
        return {
            folderName: 'Carpeta_' + empresa?.value + '_' + nombres + '_' + apellidoPaterno + '_' + apellidoMaterno,
            fileName: nombre
        }
    }
    const nationalities = [
        { value: 'us', label: 'Estados Unidos' },
        { value: 'ca', label: 'Canadá' },
        { value: 'mx', label: 'México' },
        { value: 'uk', label: 'Reino Unido' },
        { value: 'fr', label: 'Francia' },
        { value: 'de', label: 'Alemania' },
        { value: 'it', label: 'Italia' },
        { value: 'es', label: 'España' },
        { value: 'au', label: 'Australia' },
        { value: 'br', label: 'Brasil' },
        { value: 'jp', label: 'Japón' },
        { value: 'cn', label: 'China' },
        { value: 'kr', label: 'Corea del Sur' },
        { value: 'ru', label: 'Rusia' },
        { value: 'in', label: 'India' },
    ];

    const validarCarga = (info, valor) => {
        if (info.file.status === 'done') {

            if (valor === 1) {
                setFile1(info.file);
            } else if (valor === 2) {
                setFile2(info.file);
            } else if (valor === 3) {
                setFile3(info.file);
            }
        }
    }

    const mostrarCostoConsulta = async () => {
        const respuesta = await getCostoPaseMedico(empresa.value);
        setcostoPaseMedico(respuesta[0].CostoPaseMedico);
        setverModalCosto(true);
    }

    const guardarPaseMedico = async () => {
        setverModalCosto(false);
        setLoadingLinkPage(true);

        try {
            const respuesta = await postGuardarPaseMedico({ nombres, apellidoPaterno, apellidoMaterno, fechaNacimiento: moment(fechaNacimiento).format('YYYY-MM-DD'), empresa: empresa.value, genero, correoElectronico, celular, telefono, estadoCivil, nacionalidad, nombresPaciente, apellidoPaternoPaciente, apellidoMaternoPaciente, especialidad, medico, parentesco, requiereFactura, costoPaseMedico });
            console.log(respuesta); // ID DEL PACIENTE
            // SETEAR ID DEL PASE MEDICO
            setidPaseMedico(respuesta);
            // No hay que enviar respuesta aún, hay que generar link de pago con el ID del pase médico para después enviarlo al correo del paciente junto con el pase médico generado en PDF, por lo que el envío de correo se hará después de generar el link de pago y el PDF del pase médico
            // SendConfirmationEmail(respuesta);
            const linkPago = await getLinkPago(respuesta);

            if (linkPago.message) {
                console.log(linkPago.message);
                setError("Ha ocurrido un error al generar el link de pago. Por favor, inténtalo de nuevo.");
                return;
            }

            if (!linkPago.paymentLink) {
                console.log(linkPago.message);
                setError("Ha ocurrido un error al generar el link de pago. Por favor, inténtalo de nuevo.");
                return;
            }

            // hasta aqui ya tenemos el link de pago, debemos pasarlo al nuevo componente de pago para generar el iframe
            console.log("Link de pago generado:", linkPago.paymentLink);
            setLinkPago(linkPago.paymentLink);

            // testear error
            setError(null);
        } catch(error) {
            console.error("Error al guardar el pase médico:", error);
            setError("Ha ocurrido un error al guardar el pase médico. Por favor, inténtalo de nuevo.");
        }
        
        setLoadingLinkPage(false);
        setverMetodosPago(true);
    }

    return (
        <>
            <Form
                labelAlign='left'
                labelWrap
                wrapperCol={{ flex: 1 }}
            >
                <Row gutter={16}>
                    {/* NOMBRES */}
                    <Col xs={24} md={8} lg={6}>
                        <Form.Item >
                            <Input
                                value={nombres}
                                onChange={(e) => setnombres(e.target.value)}
                                id='Nombre' placeholder='Nombre (s)'
                                className={getInputStyle('Nombre')}
                                onFocus={() => handleFocus('Nombre')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('Nombre')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle} ></div>
                        </Form.Item>
                    </Col>

                    {/* APELLIDO PATERNO */}
                    <Col xs={24} md={8} lg={6}>
                        <Form.Item >
                            <Input
                                value={apellidoPaterno}
                                onChange={(e) => setapellidoPaterno(e.target.value)}
                                id='apellidoPaterno' placeholder='Apellido Paterno'
                                className={getInputStyle('apellidoPaterno')}
                                onFocus={() => handleFocus('apellidoPaterno')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('apellidoPaterno')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    {/* APELLIDO MATERNO */}
                    <Col xs={24} md={8} lg={6}>
                        <Form.Item >
                            <Input
                                value={apellidoMaterno}
                                onChange={(e) => setapellidoMaterno(e.target.value)}
                                id='apellidoMaterno' placeholder='Apellido Materno'
                                className={getInputStyle('apellidoMaterno')}
                                onFocus={() => handleFocus('apellidoMaterno')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('apellidoMaterno')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    {/* FECHA DE NACIMIENTO */}
                    <Col xs={24} md={8} lg={6}>
                        <Form.Item >
                            <DatePicker
                                value={fechaNacimiento}
                                onChange={(e) => setfechaNacimiento(e)}
                                locale={locale} format={"DD/MM/YYYY"} id="fechaNacimiento" placeholder='Fecha de nacimiento' style={{ width: "100%" }}
                                className={getInputStyle('fechaNacimiento')}
                                onFocus={() => handleFocus('fechaNacimiento')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('fechaNacimiento')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    {/* GÉNERO */}
                    <Col xs={24} md={8} lg={4}>
                        <Form.Item >
                            <Select
                                value={genero}
                                onChange={(e) => setgenero(e)}
                                id='genero' placeholder='Genero'
                                className={getSelectStyle('genero')}
                                onFocus={() => handleFocus('genero')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('genero')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <Select.Option key="Femenino" value="F">Femenino</Select.Option>
                                <Select.Option key="Masculino" value="M">Masculino</Select.Option>
                                <Select.Option key="Otro" value="O">Otro</Select.Option>
                            </Select>
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    {/* CORREO ELECTRÓNICO */}
                    <Col xs={24} md={8} lg={6}>
                        <Form.Item >
                            <Input
                                value={correoElectronico}
                                onChange={(e) => setcorreoElectronico(e.target.value)}
                                id='correoElectronico' placeholder='Correo Electrónico'
                                className={getInputStyle('correoElectronico')}
                                onFocus={() => handleFocus('correoElectronico')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('correoElectronico')}
                                onMouseLeave={handleMouseLeave}

                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    {/* CELULAR */}
                    <Col xs={24} md={8} lg={4}>
                        <Form.Item >
                            <Input
                                value={celular}
                                onChange={(e) => setcelular(e.target.value)}
                                id='celular' placeholder='Celular'
                                className={getInputStyle('celular')}
                                onFocus={() => handleFocus('celular')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('celular')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    {/* TELÉFONO */}
                    <Col xs={24} md={8} lg={4}>
                        <Form.Item >
                            <Input
                                value={telefono}
                                onChange={(e) => settelefono(e.target.value)}
                                id='telefono' placeholder='Telefono'
                                className={getInputStyle('telefono')}
                                onFocus={() => handleFocus('telefono')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('telefono')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    {/* EMPRESA */}
                    <Col xs={24} md={8} lg={6}>
                        <Form.Item >
                            <DebounceSelect
                                value={empresa}
                                showSearch optionFilterProp="label"
                                fetchOptions={fetchEmpresasList}
                                onChange={(e) => { setempresa(e) }}
                                id='empresa' placeholder='Empresa'
                                className={getSelectStyle('empresa')}
                                onFocus={() => handleFocus('empresa')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('empresa')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    {/* ESTADO CIVIL */}
                    <Col xs={24} md={8} lg={6}>
                        <Form.Item >
                            <Select
                                value={estadoCivil}
                                onChange={(e) => setestadoCivil(e)}
                                id='estadoCivil' placeholder='Estado Civil'
                                className={getSelectStyle('estadoCivil')}
                                onFocus={() => handleFocus('estadoCivil')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('estadoCivil')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <Select.Option key="Soltero" value="Soltero">Soltero</Select.Option>
                                <Select.Option key="Casado" value="Casado">Casado</Select.Option>
                                <Select.Option key="Otro1" value="Otro">Otro</Select.Option>
                            </Select>
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    {/* NACIONALIDAD */}
                    <Col xs={24} md={8} lg={6}>
                        <Form.Item >
                            <Select
                                showSearch optionFilterProp="label"
                                options={nationalities}
                                value={nacionalidad}
                                onChange={(e) => setnacionalidad(e)}
                                id='nacionalidad' placeholder='Nacionalidad'
                                className={getSelectStyle('nacionalidad')}
                                onFocus={() => handleFocus('nacionalidad')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('nacionalidad')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    {/* PARENTESCO */}
                    <Col xs={24} md={8} lg={6}>
                        <Form.Item >
                            <Select

                                value={parentesco}
                                onChange={setparentesco}
                                id='parentesco' placeholder='Parentesco'
                                className={getSelectStyle('parentesco')}
                                onFocus={() => handleFocus('parentesco')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('parentesco')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <Select.Option key={"Titular"} value="Titular">TITULAR</Select.Option>
                                <Select.Option key={"Cónyuge"} value="Cónyuge">CÓNYUGE</Select.Option>
                                <Select.Option key={"Hijo/a"} value="Hijo/a">HIJO/A</Select.Option>
                                <Select.Option key={"Padre/Madre"} value="Padre/Madre">PADRE/MADRE</Select.Option>
                            </Select>
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>
                    {
                        parentesco != null && parentesco !== "Titular" &&
                        <>
                            <Col xs={24} md={8} lg={6} >
                                <Form.Item  >
                                    <Input
                                        value={nombresPaciente}
                                        onChange={(e) => setnombresPaciente(e.target.value)}
                                        id='atendido' placeholder='Nombre (s) del paciente'
                                        className={getInputStyle('atendido')}
                                        onFocus={() => handleFocus('atendido')}
                                        onBlur={handleBlur}
                                        onMouseEnter={() => handleMouseEnter('atendido')}
                                        onMouseLeave={handleMouseLeave}
                                    />
                                    <div style={rectangleStyle}></div>

                                </Form.Item>

                            </Col>
                            <Col xs={24} md={8} lg={6} >
                                <Form.Item  >
                                    <Input
                                        value={apellidoPaternoPaciente}
                                        onChange={(e) => setapellidoPaternoPaciente(e.target.value)}
                                        id='apellidoPaternoPaciente' placeholder='Apellido paterno del paciente'
                                        className={getInputStyle('apellidoPaternoPaciente')}
                                        onFocus={() => handleFocus('apellidoPaternoPaciente')}
                                        onBlur={handleBlur}
                                        onMouseEnter={() => handleMouseEnter('apellidoPaternoPaciente')}
                                        onMouseLeave={handleMouseLeave}
                                    />
                                    <div style={rectangleStyle}></div>

                                </Form.Item>

                            </Col>
                            <Col xs={24} md={8} lg={6} >
                                <Form.Item  >
                                    <Input
                                        value={apellidoMaternoPaciente}
                                        onChange={(e) => setapellidoMaternoPaciente(e.target.value)}
                                        id='apellidoMaternoPaciente' placeholder='Apellido materno del paciente'
                                        className={getInputStyle('apellidoMaternoPaciente')}
                                        onFocus={() => handleFocus('apellidoMaternoPaciente')}
                                        onBlur={handleBlur}
                                        onMouseEnter={() => handleMouseEnter('apellidoMaternoPaciente')}
                                        onMouseLeave={handleMouseLeave}
                                    />
                                    <div style={rectangleStyle}></div>

                                </Form.Item>

                            </Col>
                        </>
                    }

                    {/* ESPECIALIDAD */}
                    <Col xs={24} md={8} lg={6}>
                        <Form.Item >
                            <Select disabled={empresa === null ? true : false} id='especialidad' placeholder='Especialidad'
                                showSearch optionFilterProp="label"
                                options={listadoEspecialidades}
                                className={getSelectStyle('especialidad')}
                                onFocus={() => handleFocus('especialidad')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('especialidad')}
                                onMouseLeave={handleMouseLeave}
                                value={especialidad}
                                onChange={(e) => setespecialidad(e)}

                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    {/* MÉDICO */}
                    <Col xs={24} md={8} lg={6}>
                        <Form.Item >
                            <Select
                                disabled={especialidad === null ? true : false}
                                id='medico' placeholder='Médico'
                                showSearch optionFilterProp="label"
                                value={medico}
                                onChange={setmedico}
                                options={listadoMedicos}
                                className={getSelectStyle('medico')}
                                onFocus={() => handleFocus('medico')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('medico')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>


                    {/* REQUIERE FACTURA */}
                    <Col xs={24} md={8} lg={4}>

                        <Form.Item label='¿Requiere Factura?'>
                            <Checkbox disabled={deshabilitarbotones} id="myCheckbox" checked={requiereFactura} onChange={(e) => setrequiereFactura(e.target.checked)} />
                        </Form.Item>

                    </Col>


                    {
                        requiereFactura === true &&
                        <>
                            <Col xs={24} md={8} lg={4} style={{ overflowY: 'auto', maxHeight: '200px' }}>
                                <Form.Item >
                                    <Select
                                        style={{ width: "100%" }}
                                        disabled={especialidad === null ? true : false}
                                        id='usoCFDI' placeholder='uso del CFDI'
                                        showSearch optionFilterProp="label"
                                        value={usoCFDI}
                                        onChange={setusoCFDI}
                                        className={getSelectStyle('usoCFDI')}
                                        onFocus={() => handleFocus('usoCFDI')}
                                        onBlur={handleBlur}
                                        onMouseEnter={() => handleMouseEnter('usoCFDI')}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <Select.Option key="D01" value="D01">D01 - HONORARIOS MEDICOS, DENTALES Y GASTOS HOSPITALARIOS</Select.Option>
                                        <Select.Option key="P01" value="P01">P01 - POR DEFINIR</Select.Option>
                                    </Select>
                                    <div style={rectangleStyle}></div>

                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8} lg={4} style={{ overflowY: 'auto', maxHeight: '200px' }}>
                                <Form.Item label={<b>Suba una fotografía o PDF de su constacia de situacion fiscal</b>}>
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8} lg={4} style={{ overflowY: 'auto', maxHeight: '200px' }}>
                                <Upload {...props} data={data("ConstanciaSituacionFiscal")} onChange={(e) => validarCarga(e, 1)}  >
                                    <Button id='cargarArchivo1' icon={<UploadOutlined />}
                                        disabled={especialidad === null ? true : false}
                                        className={getButtonStyle('cargarArchivo1')}
                                        onFocus={() => handleFocus('cargarArchivo1')}
                                        onBlur={handleBlur}
                                        onMouseEnter={() => handleMouseEnter('cargarArchivo1')}
                                        onMouseLeave={handleMouseLeave}
                                    >Cargar Archivo</Button>
                                </Upload>
                            </Col>

                        </>
                    }
                    {
                        requiereFactura === false
                    }



                    {/* GASTOS MEDICOS MAYORES */}
                    <Col xs={24} md={24} lg={6}>
                        <Form.Item label='Suba una fotografía de su tarjeta de gastos médicos mayores'>
                            <Upload {...props} data={data("GastosMedicosMayores")} onChange={(e) => validarCarga(e, 2)} >
                                <Button
                                    disabled={deshabilitarbotones}
                                    id='cargarArchivo2' icon={<UploadOutlined />}
                                    className={getButtonStyle('cargarArchivo2')}
                                    onFocus={() => handleFocus('cargarArchivo2')}
                                    onBlur={handleBlur}
                                    onMouseEnter={() => handleMouseEnter('cargarArchivo2')}
                                    onMouseLeave={handleMouseLeave}
                                >Cargar Archivo</Button>
                            </Upload>
                        </Form.Item>
                    </Col>

                    {/* IDE */}
                    <Col xs={24} md={24} lg={6}>
                        <Form.Item label='Suba una fotografía de su identificación oficial vigente'>
                            <Upload {...props} data={data("IdentificacionOficial")} onChange={(e) => validarCarga(e, 3)} >
                                <Button
                                    disabled={deshabilitarbotones}
                                    id='cargarArchivo3' icon={<UploadOutlined />}
                                    className={getButtonStyle('cargarArchivo3')}
                                    onFocus={() => handleFocus('cargarArchivo3')}
                                    onBlur={handleBlur}
                                    onMouseEnter={() => handleMouseEnter('cargarArchivo3')}
                                    onMouseLeave={handleMouseLeave}
                                >Cargar Archivo</Button>
                            </Upload>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={24} lg={24}>
                        <span className='conditions-span'>* Al comprar el pase médico acepta nuestros <Button onClick={() => {setterminosYCondiciones(!terminosYCondiciones)}} className='conditions-btn'><b>Terminos y condiciones</b></Button></span>
                    </Col>

                    {/* SUBMIT  */}
                    <Col xs={24} md={24} lg={24}>
                        <Button
                            disabled={isFilesUploaded}
                            id='comprarPase' style={{ width: '100%', backgroundColor: "#9b1c31", borderColor: "#9b1c31" }}
                            className={getButtonStyle('comprarPase')}
                            onFocus={() => handleFocus('comprarPase')}
                            onBlur={handleBlur}
                            onMouseEnter={() => handleMouseEnter('comprarPase')}
                            onMouseLeave={handleMouseLeave}
                            onClick={(e) => mostrarCostoConsulta()}
                        ><b style={{ color: 'white' }} >Comprar pase</b></Button>

                    </Col>
                </Row>
            </Form>

            {/* <Form>
                <Row gutter={16}>
                     <Col span={8}>
                        <Form.Item >
                            <Input
                                value={nombres}
                                onChange={(e) => setnombres(e.target.value)}
                                id='Nombre' placeholder='Nombre (s)'
                                className={getInputStyle('Nombre')}
                                onFocus={() => handleFocus('Nombre')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('Nombre')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle} ></div>
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item >
                            <Input
                                value={apellidoPaterno}
                                onChange={(e) => setapellidoPaterno(e.target.value)}
                                id='apellidoPaterno' placeholder='Apellido Paterno'
                                className={getInputStyle('apellidoPaterno')}
                                onFocus={() => handleFocus('apellidoPaterno')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('apellidoPaterno')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item >
                            <Input
                                value={apellidoMaterno}
                                onChange={(e) => setapellidoMaterno(e.target.value)}
                                id='apellidoMaterno' placeholder='Apellido Materno'
                                className={getInputStyle('apellidoMaterno')}
                                onFocus={() => handleFocus('apellidoMaterno')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('apellidoMaterno')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item >
                            <DatePicker
                                value={fechaNacimiento}
                                onChange={(e) => setfechaNacimiento(e)}
                                locale={locale} format={"DD/MM/YYYY"} id="fechaNacimiento" placeholder='Fecha de nacimiento' style={{ width: "100%" }}
                                className={getInputStyle('fechaNacimiento')}
                                onFocus={() => handleFocus('fechaNacimiento')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('fechaNacimiento')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item >
                            <Select
                                value={genero}
                                onChange={(e) => setgenero(e)}
                                id='genero' placeholder='Genero'
                                className={getSelectStyle('genero')}
                                onFocus={() => handleFocus('genero')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('genero')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <Select.Option key="Femenino" value="F">Femenino</Select.Option>
                                <Select.Option key="Masculino" value="M">Masculino</Select.Option>
                                <Select.Option key="Otro" value="O">Otro</Select.Option>
                            </Select>
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item >
                            <Input
                                value={correoElectronico}
                                onChange={(e) => setcorreoElectronico(e.target.value)}
                                id='correoElectronico' placeholder='Correo Electrónico'
                                className={getInputStyle('correoElectronico')}
                                onFocus={() => handleFocus('correoElectronico')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('correoElectronico')}
                                onMouseLeave={handleMouseLeave}

                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item >
                            <Input
                                value={celular}
                                onChange={(e) => setcelular(e.target.value)}
                                id='celular' placeholder='Celular'
                                className={getInputStyle('celular')}
                                onFocus={() => handleFocus('celular')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('celular')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item >
                            <Input
                                value={telefono}
                                onChange={(e) => settelefono(e.target.value)}
                                id='telefono' placeholder='Telefono'
                                className={getInputStyle('telefono')}
                                onFocus={() => handleFocus('telefono')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('telefono')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item >
                            <DebounceSelect
                                value={empresa}
                                showSearch optionFilterProp="label"
                                fetchOptions={fetchEmpresasList}
                                onChange={(e) => { setempresa(e) }}
                                id='empresa' placeholder='Empresa'
                                className={getSelectStyle('empresa')}
                                onFocus={() => handleFocus('empresa')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('empresa')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item >
                            <Select
                                value={estadoCivil}
                                onChange={(e) => setestadoCivil(e)}
                                id='estadoCivil' placeholder='Estado Civil'
                                className={getSelectStyle('estadoCivil')}
                                onFocus={() => handleFocus('estadoCivil')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('estadoCivil')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <Select.Option key="Soltero" value="Soltero">Soltero</Select.Option>
                                <Select.Option key="Casado" value="Casado">Casado</Select.Option>
                                <Select.Option key="Otro1" value="Otro">Otro</Select.Option>
                            </Select>
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item >
                            <Select
                                showSearch optionFilterProp="label"
                                options={nationalities}
                                value={nacionalidad}
                                onChange={(e) => setnacionalidad(e)}
                                id='nacionalidad' placeholder='Nacionalidad'
                                className={getSelectStyle('nacionalidad')}
                                onFocus={() => handleFocus('nacionalidad')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('nacionalidad')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item >
                            <Select

                                value={parentesco}
                                onChange={setparentesco}
                                id='parentesco' placeholder='Parentesco'
                                className={getSelectStyle('parentesco')}
                                onFocus={() => handleFocus('parentesco')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('parentesco')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <Select.Option key={"Titular"} value="Titular">TITULAR</Select.Option>
                                <Select.Option key={"Cónyuge"} value="Cónyuge">CÓNYUGE</Select.Option>
                                <Select.Option key={"Hijo/a"} value="Hijo/a">HIJO/A</Select.Option>
                                <Select.Option key={"Padre/Madre"} value="Padre/Madre">PADRE/MADRE</Select.Option>
                            </Select>
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>
                    {
                        parentesco != null && parentesco !== "Titular" &&
                        <>
                            <Col span={8} >
                                <Form.Item  >
                                    <Input
                                        value={nombresPaciente}
                                        onChange={(e) => setnombresPaciente(e.target.value)}
                                        id='atendido' placeholder='Nombre (s) del paciente'
                                        className={getInputStyle('atendido')}
                                        onFocus={() => handleFocus('atendido')}
                                        onBlur={handleBlur}
                                        onMouseEnter={() => handleMouseEnter('atendido')}
                                        onMouseLeave={handleMouseLeave}
                                    />
                                    <div style={rectangleStyle}></div>

                                </Form.Item>

                            </Col>
                            <Col span={8} >
                                <Form.Item  >
                                    <Input
                                        value={apellidoPaternoPaciente}
                                        onChange={(e) => setapellidoPaternoPaciente(e.target.value)}
                                        id='apellidoPaternoPaciente' placeholder='Apellido paterno del paciente'
                                        className={getInputStyle('apellidoPaternoPaciente')}
                                        onFocus={() => handleFocus('apellidoPaternoPaciente')}
                                        onBlur={handleBlur}
                                        onMouseEnter={() => handleMouseEnter('apellidoPaternoPaciente')}
                                        onMouseLeave={handleMouseLeave}
                                    />
                                    <div style={rectangleStyle}></div>

                                </Form.Item>

                            </Col>
                            <Col span={8} >
                                <Form.Item  >
                                    <Input
                                        value={apellidoMaternoPaciente}
                                        onChange={(e) => setapellidoMaternoPaciente(e.target.value)}
                                        id='apellidoMaternoPaciente' placeholder='Apellido materno del paciente'
                                        className={getInputStyle('apellidoMaternoPaciente')}
                                        onFocus={() => handleFocus('apellidoMaternoPaciente')}
                                        onBlur={handleBlur}
                                        onMouseEnter={() => handleMouseEnter('apellidoMaternoPaciente')}
                                        onMouseLeave={handleMouseLeave}
                                    />
                                    <div style={rectangleStyle}></div>

                                </Form.Item>

                            </Col>
                        </>
                    }

                    <Col span={8}>
                        <Form.Item >
                            <Select disabled={empresa === null ? true : false} id='especialidad' placeholder='Especialidad'
                                showSearch optionFilterProp="label"
                                options={listadoEspecialidades}
                                className={getSelectStyle('especialidad')}
                                onFocus={() => handleFocus('especialidad')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('especialidad')}
                                onMouseLeave={handleMouseLeave}
                                value={especialidad}
                                onChange={(e) => setespecialidad(e)}

                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item >
                            <Select
                                disabled={especialidad === null ? true : false}
                                id='medico' placeholder='Médico'
                                showSearch optionFilterProp="label"
                                value={medico}
                                onChange={setmedico}
                                options={listadoMedicos}
                                className={getSelectStyle('medico')}
                                onFocus={() => handleFocus('medico')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('medico')}
                                onMouseLeave={handleMouseLeave}
                            />
                            <div style={rectangleStyle}></div>

                        </Form.Item>
                    </Col>

                 <Col span={8}>&nbsp;</Col>

                    <Col span={8}>
                        <Form.Item label={<b>¿Requiere Factura?</b>}>
                            <center><Checkbox disabled={deshabilitarbotones} id="myCheckbox" checked={requiereFactura} onChange={(e) => setrequiereFactura(e.target.checked)} /></center>
                        </Form.Item>
                    </Col>
                    {
                        <>
                            {
                                requiereFactura === true &&
                                <>
                                    <Col span={6} style={{ overflowY: 'auto', maxHeight: '200px' }}>
                                        <Form.Item >
                                            <Select
                                                style={{ width: "100%" }}
                                                disabled={especialidad === null ? true : false}
                                                id='usoCFDI' placeholder='uso del CFDI'
                                                showSearch optionFilterProp="label"
                                                value={usoCFDI}
                                                onChange={setusoCFDI}
                                                className={getSelectStyle('usoCFDI')}
                                                onFocus={() => handleFocus('usoCFDI')}
                                                onBlur={handleBlur}
                                                onMouseEnter={() => handleMouseEnter('usoCFDI')}
                                                onMouseLeave={handleMouseLeave}
                                            >
                                                <Select.Option key="D01" value="D01">D01 - HONORARIOS MEDICOS, DENTALES Y GASTOS HOSPITALARIOS</Select.Option>
                                                <Select.Option key="P01" value="P01">P01 - POR DEFINIR</Select.Option>
                                            </Select>
                                            <div style={rectangleStyle}></div>

                                        </Form.Item>
                                    </Col>
                                    <Col span={6} style={{ overflowY: 'auto', maxHeight: '200px' }}>
                                        <Form.Item label={<b>Suba una fotografía o PDF de su constacia de situacion fiscal</b>}>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4} style={{ overflowY: 'auto', maxHeight: '200px' }}>
                                        <Upload {...props} data={data("ConstanciaSituacionFiscal")} onChange={(e) => validarCarga(e, 1)}  >
                                            <Button id='cargarArchivo1' icon={<UploadOutlined />}
                                                disabled={especialidad === null ? true : false}
                                                className={getButtonStyle('cargarArchivo1')}
                                                onFocus={() => handleFocus('cargarArchivo1')}
                                                onBlur={handleBlur}
                                                onMouseEnter={() => handleMouseEnter('cargarArchivo1')}
                                                onMouseLeave={handleMouseLeave}
                                            >Cargar Archivo</Button>
                                        </Upload>
                                    </Col>

                                </>
                            }
                            {
                                requiereFactura === false &&
                                <Col span={16}>&nbsp;</Col>
                            }
                        </>
                    }

                     <Col span={11} style={{ overflowY: 'auto', maxHeight: '200px' }}>
                        <Form.Item label={<b>Suba una fotografía de su tarjeta de gastos médicos mayores</b>}>
                        </Form.Item>
                    </Col>

                    <Col span={5} style={{ overflowY: 'auto', maxHeight: '200px' }}>
                        <Upload {...props} data={data("GastosMedicosMayores")} onChange={(e) => validarCarga(e, 2)} >
                            <Button
                                disabled={deshabilitarbotones}
                                id='cargarArchivo2' icon={<UploadOutlined />}
                                className={getButtonStyle('cargarArchivo2')}
                                onFocus={() => handleFocus('cargarArchivo2')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('cargarArchivo2')}
                                onMouseLeave={handleMouseLeave}
                            >Cargar Archivo</Button>
                        </Upload>
                    </Col>

                    <Col span={8}>
                        &nbsp;
                    </Col>

                    <Col span={11} style={{ overflowY: 'auto', maxHeight: '200px' }}>
                        <Form.Item label={<b>Suba una fotografía de su identificación oficial vigente</b>}>
                        </Form.Item>
                    </Col>

                    <Col id='cargarArchivo3' span={5} style={{ overflowY: 'auto', maxHeight: '200px' }}>
                        <Upload {...props} data={data("IdentificacionOficial")} onChange={(e) => validarCarga(e, 3)} >
                            <Button
                                disabled={deshabilitarbotones}
                                id='cargarArchivo3' icon={<UploadOutlined />}
                                className={getButtonStyle('cargarArchivo3')}
                                onFocus={() => handleFocus('cargarArchivo3')}
                                onBlur={handleBlur}
                                onMouseEnter={() => handleMouseEnter('cargarArchivo3')}
                                onMouseLeave={handleMouseLeave}
                            >Cargar Archivo</Button>
                        </Upload>
                    </Col>

                    <Col span={8}>
                        <Button
                            disabled={isFilesUploaded}
                            id='comprarPase' style={{ width: "100%", backgroundColor: "#9b1c31", borderColor: "#9b1c31" }}
                            className={getButtonStyle('comprarPase')}
                            onFocus={() => handleFocus('comprarPase')}
                            onBlur={handleBlur}
                            onMouseEnter={() => handleMouseEnter('comprarPase')}
                            onMouseLeave={handleMouseLeave}
                            onClick={(e) => mostrarCostoConsulta()}
                        ><b style={{ color: 'white' }} >Comprar pase</b></Button>
                    </Col>

                </Row>
            </Form > */}

            <Modal 
                title={<><h3>¿Tiene cita previa con el médico {listadoMedicos?.find((x) => x?.value === medico)?.label}?</h3></>} 
                centered 
                open={verModalTieneCita} 
                width={{
                    xs: "90%",
                    sm: "80%",
                    md: "70%",
                    lg: "60%",
                    xl: "50%"
                }} 
                footer={<></>} 
                closeIcon={<></>} >
                <Row gutter={16}>
                    <Col span={12}>
                        <Button id='confirmacion' style={{ width: "100%", backgroundColor: "#9b1c31", borderColor: "#9b1c31" }}
                            onClick={(e) => cambiarEstatusCita(true)}
                            className={getButtonStyle('confirmacion')}
                            onFocus={() => handleFocus('confirmacion')}
                            onBlur={handleBlur}
                            onMouseEnter={() => handleMouseEnter('confirmacion')}
                            onMouseLeave={handleMouseLeave}   ><b style={{ color: 'white' }}>Sí</b></Button>
                    </Col>
                    <Col span={12}>
                        <Button onClick={(e) => setverModalNoTieneCita(true)} id='negacion' style={{ width: "100%" }}
                            className={getButtonStyle('negacion')}
                            onFocus={() => handleFocus('negacion')}
                            onBlur={handleBlur}
                            onMouseEnter={() => handleMouseEnter('negacion')}
                        >No</Button>
                    </Col>


                </Row >

            </Modal>
            <Modal title={<><h3 style={{ marginBottom: "-3px" }}>Listado de médicos de la especialidad de {listadoEspecialidades?.find((x) => x?.value === especialidad)?.label}, en convenio.</h3>
                <small style={{ color: "#9b1c31", display: 'block' }}>Seleccione al médico con el que agendo su cita.</small></>} centered open={verModalNoTieneCita}
                width={"80%"} footer={<></>} closeIcon={<></>}>

                <Row gutter={16}>
                    <Col span={24}>
                        <Table columns={columns} dataSource={listadoMedicos} size='small' rowSelection={{ type: 'radio', ...rowSelection }} />
                    </Col>
                    <Col span={24}>&nbsp;</Col>
                    <Col span={24}>
                        <Row gutter={16}>
                            <Col span={8}>
                                <h3 style={{ marginLeft: "60%", marginTop: "0%" }}>¿Obtuvo su cita?</h3>
                            </Col>
                            <Col span={8}>
                                <Button id='confirmacion' style={{ width: "100%", backgroundColor: "#9b1c31", borderColor: "#9b1c31" }}
                                    onClick={(e) => cambiarEstatusCita(true)}
                                    className={getButtonStyle('confirmacion')}
                                    onFocus={() => handleFocus('confirmacion')}
                                    onBlur={handleBlur}
                                    onMouseEnter={() => handleMouseEnter('confirmacion')}
                                    onMouseLeave={handleMouseLeave}   ><b style={{ color: 'white' }}>Sí</b></Button>
                            </Col>
                            <Col span={8}>
                                <Button onClick={(e) => cambiarEstatusCita(false)}
                                    id='negacion' style={{ width: "100%" }}
                                    className={getButtonStyle('negacion')}
                                    onFocus={() => handleFocus('negacion')}
                                    onBlur={handleBlur}
                                    onMouseEnter={() => handleMouseEnter('negacion')}
                                >No</Button>
                            </Col>


                        </Row >
                    </Col>
                </Row>
            </Modal>
            <Modal 
                title={<><h3 style={{ fontSize: '1.5vw', margin: 0 }}>El costo del pase médico es de:</h3></>} 
                centered 
                open={verModalCosto} 
                width={{
                    xs: "90%",
                    sm: "80%",
                    md: "70%",
                    lg: "60%",
                    xl: "50%"
                }} 
                footer={<></>} 
                closeIcon={<></>}>
                <Row gutter={16}>
                    <Col span={2}>&nbsp;</Col>
                    <Col span={20}>
                        <div style={{ backgroundColor: '#f0f0f0', padding: '20px', textAlign: 'center', borderRadius: "10px" }}>
                            <p style={{ fontSize: '3.5vw', margin: 0 }}><b>{formatter.format(costoPaseMedico)} MXN</b></p>
                            <p style={{ color: "#9b1c31", marginTop: "0%" }}>{numeroALetras(costoPaseMedico, { plural: "PESOS", singular: "PESO", centPlural: "CENTAVOS", centSingular: "CENTAVO" })} 00/100 M.N.</p>
                        </div>
                    </Col>
                    <Col span={2}>&nbsp;</Col>
                    <Col span={12}><p style={{ fontSize: '1vw', marginTop: "5%" }}><b>¿Proceder con la compra del pase médico?</b></p></Col>
                    <Col span={6}>
                        <Button style={{ width: "100%", marginTop: "10%", backgroundColor: "#9b1c31", borderColor: "#9b1c31", color: 'white' }}
                            id='Siprocede'
                            className={getButtonStyle('Siprocede')}
                            onFocus={() => handleFocus('Siprocede')}
                            onBlur={handleBlur}
                            onMouseEnter={() => handleMouseEnter('Siprocede')}
                            onMouseLeave={handleMouseLeave}
                            onClick={(e) => guardarPaseMedico()}
                        >Sí</Button>
                    </Col>
                    <Col span={6}>
                        <Button style={{ width: "100%", marginTop: "10%" }}
                            id='Noprocede'
                            onClick={() => {setverModalCosto(false)}}
                            className={getButtonStyle('Noprocede')}
                            onFocus={() => handleFocus('Noprocede')}
                            onBlur={handleBlur}
                            onMouseEnter={() => handleMouseEnter('Noprocede')}
                            onMouseLeave={handleMouseLeave}>No</Button>
                    </Col>
                </Row>
            </Modal>
            <LinkPagoModal verLinkPagoModal={verMetodosPago} setVerLinkPagoModal={setverMetodosPago} linkPago={linkPago} error={error} />
            <Modal 
                title={<><h3 style={{ fontSize: '1vw', margin: 0 }}>Terminos y condiciones</h3></>} 
                centered 
                open={terminosYCondiciones} 
                width={{
                    xs: "90%",
                    sm: "80%",
                    md: "70%",
                    lg: "60%",
                    xl: "50%"
                }} 
                footer={<></>} 
                closeIcon={<span onClick={() => {setterminosYCondiciones(!terminosYCondiciones)}}>X</span>}>
                <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    <p>El Hospital Santander se reserva el derecho, a su entera discreción, de cambiar, modificar, añadir, quitar o actualizar los Términos y Condiciones, todo o en partes, en cualquier momento y sin previo aviso. Los cambios en los Términos y Condiciones serán efectivos cuando se publiquen. La continuación del uso de nuestro sitio web y de los servicios que ponemos a su disposición, una vez que han sido publicados los cambios, será considerado como aceptación de los mismos.</p>
                    <p style={{ paddingTop: 16 }}><b>Política de cancelación:</b> El paciente y/o familiar podrá solicitar la cancelación de citas previamente agendadas, debiendo enviar electrónicamente la solicitud al correo admin.virtual@hospitalsantander.com.mx con comprobante correspondiente a este trámite con un mínimo de 48 horas de anticipación a la fecha de su cita.</p>
                    <p style={{ paddingTop: 16 }}><b>Política de devolución:</b> Solo procede el trámite de devolución por cancelación de cita, en aquellos casos en que se encuentre la cita vigente a la fecha de la solicitud o en caso extremo de defunción del paciente; por lo que, en este caso, será el Jefe de Consulta Externa o la persona que él designe para valorar, autorizar y firmar la devolución. Para el trámite de devolución es necesario que el solicitante presente recibo de pago correspondiente. Una vez autorizada la devolución se le indicará al solicitante que debe acudir al área de cajas de Consulta Externa, con el recibo de pago autorizado, comprobante de cancelación, copia de autorización, de devolución, la credencial de elector de la persona que tramitará la devolución antes de las 17:00 hrs de lunes a viernes.</p>
                    <p style={{ paddingTop: 16 }}><b>Tratamiento de datos personales:</b> Las políticas de uso y recopilación de información de Hospital Santander referentes a la privacidad de su información se encuentran establecidas en el AVISO DE PRIVACIDAD para su consulta, por tanto, al hacer uso de este sitio está reconociendo y aceptando la responsabilidad sobre la veracidad y exactitud de la información proporcionada.</p>
                    <p style={{ paddingTop: 16 }}><b>Quejas o sugerencias:</b> El paciente y/o familiar podrá comunicar quejas o sugerencias al correo info@hospitalsantander.com.mx para ser atendido por el equipo de Atención a Pacientes.</p>
                    <div>
                        <Button onClick={() => setterminosYCondiciones(false)} style={{ display: 'block', margin: 'auto', marginTop: 16 }}>CERRAR</Button>
                    </div>
                </div>
            </Modal>

            {/* <PaymentMethod 
                idPaseMedico={idPaseMedico} 
                producto="Pase Medico" 
                cantidad={1} 
                precioUnitario={costoPaseMedico} 
                setverEstatusScreen={setverEstatusScreen} 
                setinformacionCompra={setinformacionCompra} 
                setverMetodosPago={setverMetodosPago} 
                verMetodosPago={verMetodosPago} 
                setverPaseMedico={setverPaseMedico} 
                getButtonStyle={getButtonStyle} 
                handleFocus={handleFocus} 
                handleBlur={handleBlur} 
                handleMouseEnter={handleMouseEnter} 
                handleMouseLeave={handleMouseLeave} /> */}
            
            <EstatusScreen 
                setverPaseMedico={setverPaseMedico} 
                setverEstatusScreen={setverEstatusScreen} 
                verEstatusScreen={verEstatusScreen} 
                informacionCompra={informacionCompra} />
            
            <PaseMedico 
                idPaseMedico={idPaseMedico} 
                verPaseMedico={verPaseMedico} 
                setverPaseMedico={setverPaseMedico} />
        </>

    )
}

export default MainForm
